import { MingcuteInformationLine } from '../../assets/icons/Icons'
import { selectCurrentGuestGenerateUsername } from '../../features/auth/authSlice'
import { useDispatch, useSelector } from 'react-redux'
import { clearTypeModal } from '../../features/modal/modalSlice'

export default function GuestUsername() {

    const generatedUserName = useSelector(selectCurrentGuestGenerateUsername)
    const dispatch = useDispatch();
    
    const handleContinue = () => {
        dispatch(clearTypeModal())
    }

    return (
        <div className='fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-10'>
            <div className='relative w-[80%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[40%] lg:w-[25%]'>
                <div className='flex flex-col w-full'>
                    <div className='w-full space-y-3 py-5'>
                        <div className='w-full flex justify-center'>
                            <MingcuteInformationLine width={100} height={100}/>
                        </div>
                        {/* <p className='text-[13px] md:text-[14px] text-center'>
                            {labelInfo}
                        </p> */}
                        <hr className="h-px bg-gray-200 border-0" />
                        <p className='text-[15px] text-center'>
                            Your assigned guest name is <span className='font-semibold'>{generatedUserName}</span>. Use this to resume your session next time.
                        </p>
                        <div className='w-full flex space-x-2'>
                            <button 
                                onClick={handleContinue}
                                // disabled={isLoadingStaffLogOut}
                                className='w-full bg-cbColor text-white p-2 rounded transition text-[13px] md:text-[14px]'
                            >
                                Okay
                            </button> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
